import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidateNoteService } from './note.service';
import { CandidateNote } from './note.interface';
const service = new CandidateNoteService();

export interface CandidateNoteState {}

const CandidateNoteStore: Module<CandidateNoteState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async post(context, { id, note }: { id: number; note: CandidateNote }) {
         const response = await service.post(id, note);
         return response;
      },
      async put(context, { id, noteId, note }: { id: number; noteId: number; note: CandidateNote }) {
         const response = await service.put(id, noteId, note);
         return response;
      },
      async delete(context, { candidate_id, id }: { candidate_id: number; id: number }) {
         const response = await service.delete(candidate_id, id);
         return response;
      },
   },
};

export default CandidateNoteStore;
